import '@fontsource-variable/roboto'

import initApp from './Common/base/initApp'

initApp()
